import { graphql, PageProps } from "gatsby"
import React from "react"
import Layout from "../components/layout/layout"
import Layer_2 from "../images/Layer_2.svg";
import { EmbedCode } from "../components/EmbedCode";
import * as elementor from "../elementor";
import Seo from "../components/Seo";
import { EMAIL_CAPTURE_FOOTER_ID } from "../../constants"

interface DataProps {
  page: {
    elementorData: string | null
    title: string
  }
}

function LongFormPage({ location, data: { page } }: PageProps<DataProps>) {
  const sections = elementor.load(page.elementorData);
  const navCta = sections.find(s => s.cssId === "section-nav-cta");
  const customNavBanner = sections.find(s => s.cssId === "section-custom-nav-banner");
  const { button } = navCta !== undefined ? elementor.collect(navCta) : { button: [] };
  const E = elementor.collect(
    ...sections
  );
  const logo = E.image[0];
  const title = E.heading[0];
  const description = E.textEditor[0];
  const embedCode = E.html[0];
  const steps = E.textEditor.slice(1, 5 /* maximum of 4 steps but can be changed */ );
  const emailCaptureSection = sections.find(s => s.cssId === EMAIL_CAPTURE_FOOTER_ID)

  return (
    <Layout name="long-form" location={location} ctaLink={button[0]?.link} ctaText={button[0]?.text} emailCaptureSection={emailCaptureSection} customNavBanner={customNavBanner}>
      <div className="long-form-wrapper">
        <header className="long-form-header">
          <img alt="Logo" src={ logo?.image?.fileUrl || Layer_2 }></img>
          { title && <h1 className="long-form-title">{title.title}</h1> }
          { description && <div className="long-form-description">{description.parse()}</div> }
          { steps.length > 0 &&
            <div className="card-grid">
              { steps.map(el => <div key={el.id} className="card">{el.parse()}</div>) }
            </div>
          }
        </header>
        <div id="Container" className="long-form-container long-form-analytics-container">
          { embedCode?.html && <EmbedCode fragment={embedCode.html} /> }
        </div>
      </div>
    </Layout>
  );
}

export const Head = ({ data }) => <Seo seo={data?.page?.seo}/>

export const query = graphql`
  query LongFormPage(
    $id: String!
  ) {
    page: wpPage(id: { eq: $id }) {
      elementorData
      title
      seo {
        fullHead
        metaRobotsNoindex
        metaRobotsNofollow
      }
    }
  }
`;

export default LongFormPage;
